import first from "lodash/first";
import qs from "qs";

import type { WhyRegisterPayload } from "./types";

export const getWhyRegisterActionKey = (query: string) => {
  const parsedQueryString = qs.parse(query, {
    ignoreQueryPrefix: true,
  }) as WhyRegisterPayload;

  return first(Object.keys(parsedQueryString.action?.ppto_why_reg ?? {}));
};

export const getDestinationString = (trackingActionName: string) => {
  const destination = new URL(globalThis.location.origin + globalThis.location.pathname);

  destination.search = `action[ppto_why_reg][${trackingActionName}]`;

  return destination.toString();
};
